 
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import LazyLoad from 'react-lazyload';
const VideoGallery = () => { 
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true, 
  };
 

  return (
    <>
       
        <Slider {...settings}> 
               <div className="item">
                        <div className="galleryimg homevideo">
                        <div className="galleryimgbox">
                            <LazyLoad><img src="https://webapi.entab.info/api/image/MMATD/public/Images/videogallery.jpg" className="img-fluid"  alt="MMATD"
                        /></LazyLoad>
                        <div className="gallerydesc">
                            <Link target='_blank' to="https://www.youtube.com/watch?v=pkCvIBvumaw" className="gallery_button"> <LazyLoad><img src="https://webapi.entab.info/api/image/MMATD/public/Images/videogalleryicn.png" className="img-fluid"  alt="MMATD"
                            /></LazyLoad> </Link>
                            <h6> School Video</h6>
                        </div>
                        </div> 
                    </div>
                </div> 
        </Slider>
      
    </>
  );
};

export default VideoGallery;
